"use client";
import {useRouter} from "next/navigation";
import React, { useEffect } from "react";
import {useAppDispatch} from "@/app/storeHooks";
import { Button } from "@/app/_components";
import { SDialogFC, SDialogProps } from "@/Master/SDialogFC/SDialogFC";
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";
import {getUserInfoAsync} from "@/app/userSliceAPI";
import styles from "./RewardDialog.module.css";
import {DriveUtil} from "@/Master/DriveUtil";

export interface RewardDialogProps extends SDialogProps {
    gcCount: number;
    scCount: number;
}

export const RewardDialogFC: React.FC<RewardDialogProps> = (props) => {
    const {fcKey, onClose,gcCount,scCount} = props;
    const {closeDialog} = useDialogMethods(fcKey);

    const router = useRouter();
    const dispatch = useAppDispatch();

    useEffect(() => {
        console.log("RewardDialog initialized");
        return () => {
            console.log("RewardDialog disposed");
        };
    }, []);

    const onClick = async () => {
        await dispatch(getUserInfoAsync());
        closeDialog();
        onClose?.();
        // GameMsgUtil.sendMsgLowerSyncData();
    }

    return (
        <SDialogFC
            fcKey={fcKey}
            mode="Full"
            title="\n\n\n"
        >
            <section className={styles.layer}>

                <section className={styles.panel}></section>

                <section className={styles.top_wrapper}>
                    {/*<div className={styles.light}></div>*/}
                    <img className={styles.light} src="/img/general-gift/img_light.webp" width="100%" alt=""/>
                    <section className={styles.title}>
                        <img
                            className={`${styles.star_left}`}
                            src="/img/general-gift/star_left.webp"
                            alt=""
                        />
                        <img
                            className={`${styles.line_left}`}
                            src="/img/general-gift/line_left.webp"
                            alt=""
                        />
                        <img
                            className={`${styles.line_red_left}`}
                            src="/img/general-gift/line_red_left.webp"
                            alt=""
                        />
                        <img
                            className={`${styles.star_sm_left}`}
                            src="/img/general-gift/star_sm_left.webp"
                            alt=""
                        />
                        CONGRATULATION!
                        <img
                            className={`${styles.star_right}`}
                            src="/img/general-gift/star_right.webp"
                            alt=""
                        />
                        <img
                            className={`${styles.line_right}`}
                            src="/img/general-gift/line_right.webp"
                            alt=""
                        />
                        <img
                            className={`${styles.line_sm_right}`}
                            src="/img/general-gift/line_sm_right.webp"
                            alt=""
                        />
                        <img
                            className={`${styles.star_sm_right}`}
                            src="/img/general-gift/star_sm_right.webp"
                            alt=""
                        />
                        <img
                            className={`${styles.star_xsm_right}`}
                            src="/img/general-gift/star_xsm_right.webp"
                            alt=""
                        />
                    </section>
                </section>

                <section className={styles.container}>
                    {scCount > 0 && <>
                        <section className={styles.flex_left}>
                            <div className={styles.relative}>
                                <div className={`${styles.star}`}></div>
                                <div className={`${styles.star_sm}`}></div>
                                <div className={`${styles.star_sm} ${styles.star_sm_rt}`}></div>
                                <img
                                    className={styles.img_gold}
                                    src="/img/ico_sc_big.png"
                                    alt=""
                                />
                            </div>

                            <div className={styles.sc_num}>{DriveUtil.ToScString(scCount, true)}</div>
                        </section>
                    </>}
                    <section className={styles.flex_right}>
                        <div className={styles.relative}>
                            <div className={styles.relative}>
                                <div className={`${styles.star}`}></div>
                                <div className={`${styles.star_sm}`}></div>
                                <div className={`${styles.star_sm} ${styles.star_sm_rt} ${styles.star_sm_rt2}`}></div>
                                <img
                                    className={styles.img_gold}
                                    src="/img/ico_gc_big.png"
                                    alt=""
                                />
                            </div>
                        </div>
                        <div className={styles.gc_num}>{DriveUtil.ToGcKMBTUnitString(gcCount, true)}</div>
                    </section>
                </section>

                <section style={{textAlign: "center", marginTop: "1.9rem"}}>
                    <Button
                        color="#0090FF"
                        style={{
                            color: '#fff',
                            width: '5rem',
                            height: '1.15rem',
                            fontSize: '.6rem',
                            fontWeight: 900,
                        }}
                        onClick={onClick}
                    >
                        Claim
                    </Button>
                </section>
            </section>
        </SDialogFC>
    );
};
